import LoadableContent from './LoadableContent';

export default LoadableContent;



// WEBPACK FOOTER //
// ./src/components/LoadableContent/index.ts